<template>
    <div class="main-container">
        <div class="content-container">
            <div class="row1">

                <div class="row1-first">
                    <flower-spinner
                            :animation-duration="2500"
                            :size="70"
                            color="#e9430f"
                    />
                </div>

                <div class="row1-second">
                    <scaling-squares-spinner
                            :animation-duration="1250"
                            :size="65"
                            color="#e9430f"
                    />
                </div>

                <div class="row1-third">
                    <trinity-rings-spinner
                            :animation-duration="1500"
                            :size="66"
                            color="#e9430f"></trinity-rings-spinner>

                </div>
            </div>


            <div class="row2">

                <div class="row2-first">
                <semipolar-spinner
                        :animation-duration="2000"
                        :size="65"
                        color="#e9430f"></semipolar-spinner>
                </div>

                <h1 class="row2-second">Coming Soon</h1>

                <div class="row2-third">
                    <breeding-rhombus-spinner
                            :animation-duration="2000"
                            :size="65"
                            color="#e9430f"
                    />
                </div>

            </div>


            <div class="row3">

                <div class="row3-first">
                    <fulfilling-square-spinner
                            :animation-duration="4000"
                            :size="50"
                            color="#e9430f"
                    />
                </div>

                <div class="row3-second">
                    <fingerprint-spinner
                            :animation-duration="1500"
                            :size="64"
                            color="#e9430f"
                    />
                </div>
                <div class="row3-third">
                    <half-circle-spinner
                            :animation-duration="1000"
                            :size="60"
                            color="#e9430f"
                    />
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { FlowerSpinner } from 'epic-spinners'
    import { TrinityRingsSpinner } from 'epic-spinners'
    import { SemipolarSpinner  } from 'epic-spinners'
    import { BreedingRhombusSpinner } from 'epic-spinners'
    import { FulfillingSquareSpinner } from 'epic-spinners'
    import { HalfCircleSpinner } from 'epic-spinners'
    import { ScalingSquaresSpinner  } from 'epic-spinners'
    import { FingerprintSpinner } from 'epic-spinners'

    export default {
        name: "ComingSoon",
        components: {
            FlowerSpinner,
            TrinityRingsSpinner,
            SemipolarSpinner,
            BreedingRhombusSpinner,
            FulfillingSquareSpinner,
            HalfCircleSpinner,
            ScalingSquaresSpinner,
            FingerprintSpinner
        }
    }
</script>

<style lang="scss" scoped>

    @import "@/assets/css/colors.scss";

    .main-container {
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;

        .content-container {

            display: flex;
            flex-direction: column;
            align-content: center;
            justify-content: center;
            width: 100%;
            height: 100%;

            div {
                display: flex;
                flex-direction: row;
                align-content: center;
                justify-content: center;

                .row1-first {
                    padding-bottom: 10%;
                    padding-right: 10%;
                }
                .row1-second {
                    padding-top: 5%
                }
                .row1-third {
                    padding-top: 4%;
                    padding-left: 10%;
                }

                .row2-first {
                    padding-right: 5%;
                }
                .row2-second {
                    padding-left: 15%;
                    font-family: 'Roboto Slab', sans-serif;
                    font-size: 300%;
                    color: $primary-color;
                    text-align: left;
                    font-weight: bolder;
                }
                .row2-third {
                    padding-left: 20%;
                }


                .row3-first {
                    padding-top: 10%;
                    padding-left: 5%;
                }
                .row3-second {
                    padding-left: 15%;
                    padding-top: 5%;
                }
                .row3-third {
                    padding-left: 20%;
                    padding-top: 10%;
                }
            }
        }
    }
</style>